import { render, staticRenderFns } from "./CaseLedgerPDF.vue?vue&type=template&id=bc92b978&scoped=true"
import script from "./CaseLedgerPDF.vue?vue&type=script&lang=js"
export * from "./CaseLedgerPDF.vue?vue&type=script&lang=js"
import style0 from "./CaseLedgerPDF.vue?vue&type=style&index=0&id=bc92b978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc92b978",
  null
  
)

export default component.exports